import React, { FC }                  from 'react';
import { Button, Theme, ButtonProps } from '@material-ui/core';
import { makeStyles, createStyles }   from '@material-ui/core/styles';
import { ILinkButtonData }            from '@typings/components';

type TProps = ButtonProps & ILinkButtonData;

const useStyles = makeStyles<Theme, Pick<TProps, 'active'>>(({ palette }) => createStyles({
  button: ({ active }) => ({
    textDecoration : 'underline',
    color          : active ? palette.error.main : palette.secondary.main,
    '&:hover'      : {
      backgroundColor : 'initial',
      textDecoration  : 'none',
    },
  }),
}));

export const LinkButton: FC<TProps> = ({
  label,
  active,
  size = 'small',
  ...props
}) => {
  const { button } = useStyles({ active });

  return (
    <Button
      classes = {{ root: button }}
      variant = "text"
      size    = {size}
      {...props}
      disableRipple
    >
      {props.children || label}
    </Button>
  );
};
